<template>
    <div id="expand-mini-chart" class="mini-bar-chart">
        <apexchart type="bar" width="350" height="300" :options="options" :series="chartData"></apexchart>
    </div>
</template>

<script>
    export default {
        props: {
            seriesData: {
                type: Array
            },
            category: {
                type: Array
            }
        },
        computed: {
            chartData() {
                return [{
                    'data': this.seriesData
                }]
            },
            options() {
                return {
                    chart: {
                        id: 'expand-mini-chart',
                        width: '100%',
                        toolbar: {
                            show: false
                        }
                    },
                    xaxis: {
                        categories: this.category,
                    }
                }
            }
        }
    }
</script>

<style lang="css" scoped>
.mini-bar-chart {
    display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/Analytics/ExpandMiniBarChart.vue